<template>
    <div class="main-div">
        <header-create-group-chat @closeDialog="closeDialog" />
        <main-create-group-chat @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import HeaderCreateGroupChat from './HeaderCreateGroupChat.vue';
import MainCreateGroupChat from './MainCreateGroupChat.vue';

const dialogRef = getDialogRef(ModalNames.CREATE_GROUP_CHAT);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-md sm:w-full w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
</style>